<span>
  <i class="fa fa-spin fa-spinner"></i>
  Loading ...
</span>